/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Spotify24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Spotify 24">
      <path
        fill="#0E0E0E"
        d="M18.173 17.998c-.252.405-.789.518-1.208.275-3.307-1.943-7.453-2.38-12.354-1.311-.47.097-.94-.178-1.04-.632a.838.838 0 0 1 .654-1.004c5.354-1.182 9.953-.68 13.646 1.506a.83.83 0 0 1 .302 1.166Zm1.712-3.692c-.319.502-.99.648-1.51.356-3.777-2.25-9.534-2.898-14-1.587-.587.162-1.191-.145-1.359-.696a1.042 1.042 0 0 1 .739-1.312c5.102-1.49 11.447-.777 15.794 1.798.487.291.655.939.336 1.44Zm.151-3.854c-4.532-2.59-12.001-2.834-16.332-1.57a1.32 1.32 0 0 1-1.645-.843c-.218-.664.185-1.376.873-1.587 4.969-1.457 13.227-1.166 18.43 1.814a1.24 1.24 0 0 1 .453 1.733 1.29 1.29 0 0 1-1.779.453Z"
        className="SVG"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Spotify24,
  md: Spotify24,
  lg: Spotify24,
  xl: Spotify24,
  xxl: Spotify24,
  xxxl: Spotify24,
};

export const SpotifyIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'spotify-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
